import React, { useEffect, useRef } from 'react';
import Chart, {
    AdaptiveLayout,
    CommonSeriesSettings,
    SeriesTemplate,
    Size,
    Tooltip,
    ValueAxis,
} from 'devextreme-react/chart';
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source';
import PivotGrid, {
    FieldChooser, FieldPanel,
} from 'devextreme-react/pivot-grid';
const SummaryPivotGrid = ({ dataSource }) => {
    const chartRef = useRef();
    const pivotGrid = useRef();
    useEffect(() => {
        pivotGrid.current.instance.bindChart(chartRef.current.instance, {
            dataFieldsDisplayMode: 'splitPanes',
            alternateDataFields: false,
        });
        setTimeout(() => {
            // debugger
            pivotDataSource.expandAll();
            // dataSource.expandHeaderItem('row', ['North America']);
            // pivotDataSource.expandHeaderItem('column', [2022, "2022/Q4"]);
            // pivotDataSource.expandHeaderItem('column', ["Q4"]);
        });
    }, [])
    const getKhoiName = (dm_khoi_id, khoi_lop) => {
        if (dm_khoi_id && dm_khoi_id >= 1 && dm_khoi_id <= 5) return "Tiểu học";
        if (dm_khoi_id && dm_khoi_id >= 6 && dm_khoi_id <= 13) return "Trung học";
        if (khoi_lop && khoi_lop.toUpperCase().includes('TIỂU')) return "Tiểu học";
        if (khoi_lop && khoi_lop.toUpperCase().includes('TRUNG')) return "Trung học";
        return "Unknow";
    }
    const pivotDataSource = new PivotGridDataSource({
        fields: [{
            caption: 'Chiến dịch',
            width: 250,
            dataField: 'ten_chien_dich',
            area: 'row',
            sortBySummaryField: 'Total',
        },
        {
            caption: 'Year',
            dataField: 'khoi',
            width: 150,
            area: 'row',
        },
        {
            dataField: 'register_date',
            dataType: 'date',
            area: 'column',
            expanded: true
        },
        {
            groupName: 'date',
            groupInterval: 'month',
            visible: true,
            expanded: true
        },
        {
            caption: 'Total',
            dataField: 'id',
            dataType: 'number',
            summaryType: 'count',
            // format: 'currency',
            // summaryDisplayMode: 'absoluteVariation',
            area: 'data',
        }
        ],
        store: dataSource.map(x => ({
            id: x.id,
            ten_chien_dich: x.ten_chien_dich,
            register_date: x.register_date,
            khoi: getKhoiName(x.dm_khoi_id, x.khoi_lop)
        })),
    });

    const customizeTooltip = (args) => {
        // const valueText = currencyFormatter.format(args.originalValue);
        return {
            html: `${args.seriesName} | Total<div class="currency">${args.originalValue}</div>`,
        };
    }
    return (
        <div>
            <Chart ref={chartRef} valueAxis={{
                tick: 100
            }}>
                <Size height={300} />
                <Tooltip enabled={true} customizeTooltip={customizeTooltip} />
                <CommonSeriesSettings type="bar" barPadding={0.5} barWidth={20} />
                {/* <SeriesTemplate nameField="question_group_short_name" />
                <ValueAxis valueType="numeric" tickInterval={10}>
                </ValueAxis> */}
            </Chart>
            <div>
                <p>&nbsp;</p>
            </div>
            <PivotGrid
                id="pivotgrid"
                dataSource={pivotDataSource}
                allowSortingBySummary={true}
                allowFiltering={true}
                showBorders={true}
                showColumnTotals={false}
                showColumnGrandTotals={false}
                showRowTotals={false}
                showRowGrandTotals={false}
                ref={pivotGrid}
            >
                <FieldPanel
                    showFilterFields={false}
                    allowFieldDragging={false}
                    visible={false}
                />
                <FieldChooser enabled={true} height={400} />
            </PivotGrid>
        </div>
    );
};

export default SummaryPivotGrid;